define((require) => {
    "use strict";

    const $             = require("jquery");
    const Class         = require("shared/util/Class");
    const Configuration = require("shared/services/Configuration");

    const FontsDotComApi = Class.extend({
        /**
         * Returns all the fonts from Fonts.com available to the current company. The list is a
         * union of all the Fonts.com font projects that are associated with the current company's
         * authentication key.
         *
         * @returns {Promise<FontDescriptor[]>}
         */
        all() {
            return this._get("fonts");
        },

        /**
         * Validates a Fonts.com authentication key.
         *
         * @param {String} authenticationKey Hexadicimal key, 121 characters long including dashes.
         * @returns {Promise<Boolean>}
         */
        validate(authenticationKey) {
            return this._get("validate", {authenticationKey});
        },

        _get(urlPath, options) {
            const path = `${Configuration.adminApiBaseUrl}/api/external/fontsdotcom/${urlPath}`;
            return $.getJSON(path, options)
                .then((response) => response);
        }
    });

    return new FontsDotComApi();
});



// WEBPACK FOOTER //
// ./src/editor/services/fonts/FontsDotComApi.js